import { create } from "zustand"
import { devtools } from 'zustand/middleware'

import { getCountInfoApp } from "./api"
import { IInfoBadgeCRM } from "./api.types"
import { IMainActions, IMainState } from "./state.types"


/** Изначальное состояние хранилища */
export const initialStateMain: IMainState = {
    badge: {} as IInfoBadgeCRM
}

/** Храниелище страницы - Main */
export const useMain = create<IMainState & IMainActions>()(devtools((set) => ({
    ...initialStateMain,

    /** Получение информации по системе (BADGE) */
    actionGetCountInfoApp: async (isSystemRequest: boolean = false) => {
        const response = await getCountInfoApp(isSystemRequest)

        if (response.status === 200) {
            set({ badge: response.data })
        }

        return response
    },
}), {name: 'StateMain'}))